import { render, staticRenderFns } from "./Verificaciones.vue?vue&type=template&id=16c211ba&"
import script from "./Verificaciones.vue?vue&type=script&lang=js&"
export * from "./Verificaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QToolbar,QToolbarTitle,QSpace,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QBtn,QTimeline,QTimelineEntry} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QToolbar,QToolbarTitle,QSpace,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QBtn,QTimeline,QTimelineEntry})
